import { VideoContext, VideoProvider } from "hooks/useContext/useVideoContext"
import VideoCall from "pages/VideoCall"

export default function VideoChat() {
  return (
    <VideoProvider value={VideoContext}>
      <VideoCall />
    </VideoProvider>
  )
}